/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { CronRequest } from '../../models/cron-request';
import { JobCrons } from '../../models/job-crons';

export interface SaveCron$Params {
   body: CronRequest;
}

export function saveCron(
   http: HttpClient,
   rootUrl: string,
   params: SaveCron$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<JobCrons>> {
   const rb = new RequestBuilder(rootUrl, saveCron.PATH, 'post');
   if (params) {
      rb.body(params.body, 'application/json');
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<JobCrons>;
      })
   );
}

saveCron.PATH = '/api/weather/job/cron';
